import React, { useState, useEffect } from "react";
import { CloseButton, Modal, Card, Col, Row, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link } from 'react-router-dom';
import BrokerService from "../../../services/broker.service";
import kite from '../../../assets/img/login-img/kite-connect.webp';
import Alice from '../../../assets/img/login-img/alice.webp';
import Fyers from '../../../assets/img/login-img/Logo-fyers-final.webp';
import ICICI from '../../../assets/img/login-img/icic.webp';
import AngelBooking from '../../../assets/img/login-img/angel_booking.webp';
import paisa from '../../../assets/img/login-img/5paisa.webp';
import jainam from '../../../assets/img/login-img/jainam.png';
import Dhanlog from '../../../assets/img/login-img/dhan.jpg';
import upstock from '../../../assets/img/login-img/upstock.webp';
import flattrade from '../../../assets/img/login-img/flattrade-1.png';
import shoonya from '../../../assets/img/login-img/shoonya-logo.png';
import xts from '../../../assets/img/login-img/xts.png';
import firstock from '../../../assets/img/login-img/firstock.png';
import kotakneo from '../../../assets/img/login-img/kotakneo.png';
import jainamXTS from "../../../assets/img/login-img/jainam.webp";
import zebu from "../../../assets/img/login-img/zebu.svg";
import groww from "../../../assets/img/login-img/groww_logo.webp";
import arrow from "../../../assets/img/login-img/arrow.svg";

import { getLocalStorageObject, setLocalStorageObject } from "../../../util/helper";
import { X } from "lucide-react";
import { useToast } from "components/common/custom-toast/Toast";
let localStorageObj = getLocalStorageObject("login-id") || {
  Zerodha: "",
  Aliceblue: "",
  Fyers: "",
  ICICI: "",
  AngelOne: "",
  fivePaisa: "",
  Jainam: "",
  upstox: "",
  dhan: "",
  flattrade: "",
  shoonya: "",
  paperbroker: "",
  kotakneo: "",
  firstock: "",
  jainamxts: "",
  zebu: "",
  arrow: "",
  groww: ""
};
const BrokerLoginModal = (props) => {
  const navigate = useNavigate();
  const [clientID, setClientID] = useState('');
  const [errMsg, setError] = useState('');
  const toast = useToast()

  useEffect(() => {
    setClientID("");
    setError("");
  }, [props]);

  useEffect(() => {

    if (props.inputRef && props.inputRef.current) {
      props.inputRef.current.focus();
    }
    var name = "";
    if (props.loginType == 0) {
      name = "Zerodha";
    }
    if (props.loginType == 1) {
      name = "Aliceblue";
    }
    if (props.loginType == 2) {
      name = "Fyers";
    }
    if (props.loginType == 3) {
      name = "ICICI";
    }
    if (props.loginType == 4) {
      name = "AngelOne";
    }

    if (props.loginType == 5) {
      name = "fivePaisa";
    }

    if (props.loginType == 6) {
      name = "jainam";
    }

    if (props.loginType == 7) {
      name = "upstox";
    }

    if (props.loginType == 8) {
      name = "dhan";
    }

    if (props.loginType == 9) {
      name = "flattrade";
    }

    if (props.loginType == 10) {
      name = "shoonya";
    }

    if (props.loginType == 11) {
      name = "xts";
    }
    if (props.loginType == 12) {
      name = "paperbroker";
    }
    if (props.loginType == 13) {
      name = "jainamxts";
    }
    if (props.loginType == 14) {
      name = "kotakneo";
    }
    if (props.loginType == 15) {
      name = "firstock";
    }
    if (props.loginType == 16) {
      name = "zebu";
    }
    if (props.loginType == 17) {
      name = "arrow";
    }
    if (props.loginType == 18) {
      name = "groww";
    }
    setClientID(getLocalStorageObject("login-id")?.[name] || "")
  }, [props]);
  const loginAsBorker = (e) => {

    if ((e.keyCode == 13 && clientID) || e == "") {
      const brokersRequiringSetup = [0, 1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 13, 14, 15, 16, 17, 18];

      if (brokersRequiringSetup.includes(Number(props.loginType))) {
        BrokerService.getBrokers().then(
          response => {
            if (response.code === 200) {

              if (response.data.brokers) {
                var filterUsername = response.data.brokers.filter((item) => item.userName == clientID);
                if (filterUsername.length > 0) {
                  if (typeof props.onChanged === 'function') { props.onChanged(); }
                  return;
                } else {
                  navigate("/broker-setup", {
                    state: {
                      userName: clientID,
                      loginTypeSubType: props.loginTypeSubType,
                      type: props.loginType == 0 ? 'zerodha' : props.loginType == 9 ? 'flattrade' : props.loginType == 7 ? 'upstox' : props.loginType == 10 ? 'shoonya' : props.loginType == 16 ? 'zebu' : props.loginType == 8 ? 'dhan' : props.loginType == 2 ? 'fyers' : (props.loginType == 11) ? 'xtsRetail' : props.loginType == 13 ? 'xtsProp' : props.loginType == 14 ? 'kotakneo' : props.loginType == 15 ? 'firstock' : props.loginType == 1 ? 'aliceblue' : props.loginType == 4 ? 'angelone' : props.loginType == 5 ? '5paisa' : props.loginType == 17 ? 'arrow' : props.loginType == 18 ? 'groww' : 'icici',
                    }
                  });
                }

              } else {
                navigate("/broker-setup", {
                  state: {
                    userName: clientID,
                    loginTypeSubType: props.loginTypeSubType,
                    type: props.loginType == 0 ? 'zerodha' : props.loginType == 9 ? 'flattrade' : props.loginType == 7 ? 'upstox' : props.loginType == 10 ? 'shoonya' : props.loginType == 16 ? 'zebu' : props.loginType == 8 ? 'dhan' : props.loginType == 2 ? 'fyers' : (props.loginType == 11) ? 'xtsRetail' : props.loginType == 13 ? 'xtsProp' : props.loginType == 14 ? 'kotakneo' : props.loginType == 15 ? 'firstock' : props.loginType == 1 ? 'aliceblue' : props.loginType == 4 ? 'angelone' : props.loginType == 5 ? '5paisa' : props.loginType == 17 ? 'arrow' : props.loginType == 18 ? 'groww' : 'icici',
                  }
                });
              }

            } else {
              toast.error('session expired');
            }
          },
          error => {
            setError((error.response && error.response.data) || error.message || error.toString());
          }
        );

      } else {

        var brokerAddParma = {
          "name": props.loginType == 6 ? 'jainam' : props.loginType == 12 ? 'Paper Trading' : '',
          "type": props.loginType == 6 ? 'jainam' : props.loginType == 12 ? 'papertrading' : '',
          "autoLogin": false,
          "loginType": "partner",
          "configuration": {
            "userName": clientID,
            "apiKey": "",
            "secret": ""
          }
        };


        BrokerService.addBroker(brokerAddParma).then(
          response => {

            if (response.code == 500) {
              setError("Something went wrong. Please contact support!")
            } else if (response.code == 403) {
              navigate("/authentication/login");
            } else {

              if (response.error == "broker name already used") {
                if (typeof props.onChanged === 'function') { props.onChanged(); }
                return
              } else {
                if (response.code == 200) {

                  BrokerService.getBrokers().then(
                    brokersRes => {
                      if (brokersRes.code === 200) {

                        if (brokersRes.data.brokers) {
                          var filterUsername = brokersRes.data.brokers.filter((item) => item.type == response.data.type);
                          if (filterUsername && filterUsername.length > 0) {
                            window.location.replace(filterUsername[0].manualLoginURL);
                          }
                        }

                      } else {
                        toast.error('session expired');
                      }
                    },
                    error => {

                    }
                  );
                } else {
                  setError(response.error)
                }
              }
            }
          },
          error => {
            setError("Something went wrong. Please contact support!")
          }

        );
        // 
      }
    }
  }

  const handleChange = (event) => {
    setError("");
    setClientID(event.target.value.toUpperCase());
    var name = "";
    if (props.loginType == 0) {
      name = "Zerodha";
    }
    if (props.loginType == 1) {
      name = "Aliceblue";
    }
    if (props.loginType == 2) {
      name = "Fyers";
    }
    if (props.loginType == 3) {
      name = "ICICI";
    }
    if (props.loginType == 4) {
      name = "AngelOne";
    }

    if (props.loginType == 5) {
      name = "fivePaisa";
    }
    if (props.loginType == 6) {
      name = "jainam";
    }

    if (props.loginType == 7) {
      name = "upstox";
    }

    if (props.loginType == 8) {
      name = "dhan";
    }
    if (props.loginType == 9) {
      name = "flattrade";
    }

    if (props.loginType == 10) {
      name = "shoonya";
    }

    if (props.loginType == 11) {
      name = "xts";
    }
    if (props.loginType == 12) {
      name = "paperbroker";
    }
    if (props.loginType == 13) {
      name = "jainamxts";
    }
    if (props.loginType == 14) {
      name = "kotakneo";
    }
    if (props.loginType == 15) {
      name = "firstock";
    }
    if (props.loginType == 16) {
      name = "zebu";
    }
    if (props.loginType == 17) {
      name = "arrow";
    }
    if (props.loginType == 18) {
      name = "groww";
    }
    setLocalStorageObject('login-id', name, event.target.value.toUpperCase(), localStorageObj);


  };
  return (
    <>
      <style>{`
      .modal-dialog.broker-login-modal { max-width: 420px; }
      .broker-login-modal .modal-header { padding: 0.75rem 1rem; }
      .broker-login-modal .modal-body { padding: 1rem 1.25rem; }
    `}</style>
      <Modal show={props.show} onHide={props.close} centered size="sm" dialogClassName="broker-login-modal">
        <Modal.Header className="bg-primary modal-shape-header px-3 position-relative">
          <div className="position-relative z-index-1 light">
            <h5 className="mb-0 text-white" id="authentication-modal-label" style={{ whiteSpace: 'nowrap' }}>
              {props.loginType == 0 ? 'Zerodha' : props.loginType == 1 ? 'Aliceblue' : props.loginType == 2 ? 'Fyers' : props.loginType == 3 ? 'ICICI Direct' : props.loginType == 4 ? 'Angel One' : props.loginType == 5 ? '5Paisa' : props.loginType == 6 ? "Jainam Duck" : props.loginType == 7 ? "Upstox" : props.loginType == 8 ? "Dhan" : props.loginType == 9 ? "FlatTrade" : props.loginType == 10 ? "Shoonya" : props.loginType == 11 ? "XTS" : props.loginType == 13 ? "Jainam (XTS)" : props.loginType == 14 ? "Kotak Neo" : props.loginType == 15 ? "Firstock" : props.loginType == 16 ? "Zebu" : props.loginType == 17 ? "Arrow" : props.loginType == 18 ? "Groww" : ""} User Authentication

            </h5>
          </div>
          <X
            style={{ color: "#FFF", cursor: "pointer" }}

            className=""
            onClick={props.close}
          />
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row className="justify-content-md-center">
            <Col xs={12} sm={4} md={4} className="flex justify-content-md-center text-center">
              {props.loginType == 0 ?
                <img
                  className="text-center"
                  src={kite}
                  alt=""
                  width={120}
                /> : props.loginType == 1 ?
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <img
                      className="text-center"
                      src={Alice}
                      alt=""
                      width={30}
                      style={{ borderRadius: "0.25rem" }}
                    />
                    <h5 className="text-center">Aliceblue</h5>
                  </div>
                  : props.loginType == 2 ?
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        className="text-center"
                        src={Fyers}
                        alt=""
                        width={40}
                      />
                      <h5 className="text-center">Fyers</h5>
                    </div>

                    : props.loginType == 3 ?
                      <div className="d-flex justify-content-center align-items-center">
                        <img
                          className="text-center"
                          src={ICICI}
                          alt=""
                          width={26}
                          style={{ marginRight: "5px" }}
                        />
                        <h5 className="text-center" style={{ whiteSpace: 'nowrap' }}>ICICI Direct</h5>
                      </div>
                      : props.loginType == 4 ?
                        <div className="d-flex justify-content-center align-items-center mb-3">
                          <img
                            className="text-center"
                            src={AngelBooking}
                            alt=""
                            width={26}
                            style={{ marginRight: "5px" }}
                          />
                          <h5 className="text-center">Angel One</h5>
                        </div> : props.loginType == 5 ?
                          <div className="d-flex justify-content-center align-items-center">
                            <img
                              className="text-center"
                              src={paisa}
                              alt=""
                              width={26}
                              style={{ marginRight: "5px" }}
                            />
                            <h5 className="text-center">5Paisa</h5>
                          </div> : props.loginType == 6 ?
                            <div className="d-flex justify-content-center align-items-center mb-3">
                              <img
                                className="text-center"
                                src={jainam}
                                alt=""
                                width={100}
                                style={{ marginRight: "5px" }}
                              />
                            </div> : props.loginType == 7 ?
                              <div className="d-flex justify-content-center align-items-center mb-3">
                                <img
                                  className="text-center"
                                  src={upstock}
                                  alt=""
                                  width={34}
                                  style={{ marginRight: "5px" }}
                                />
                                <h5 className="text-center">Upstox</h5>
                              </div> : props.loginType == 8 ?
                                <div className="d-flex justify-content-center align-items-center mb-3">
                                  <img
                                    className="text-center"
                                    src={Dhanlog}
                                    alt=""
                                    width={34}
                                    style={{ marginRight: "5px" }}
                                  />
                                  <h5 className="text-center">Dhan</h5>
                                </div> : props.loginType == 9 ?
                                  <div className="d-flex justify-content-center align-items-center mb-3">
                                    <img
                                      className="text-center"
                                      src={flattrade}
                                      alt=""
                                      width={100}
                                      style={{ marginRight: "5px" }}
                                    />
                                  </div> : props.loginType == 10 ?
                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                      <img
                                        className="text-center"
                                        src={shoonya}
                                        alt=""
                                        width={34}
                                        style={{ marginRight: "5px" }}
                                      />
                                      <h5 className="text-center">Shoonya</h5>
                                    </div> : props.loginType == 11 ?
                                      <div className="d-flex justify-content-center align-items-center">
                                        <img
                                          className="text-center"
                                          src={xts}
                                          alt=""
                                          width={70}
                                          style={{ marginRight: "5px" }}
                                        />
                                      </div> : props.loginType == 13 ?
                                        <div className="d-flex justify-content-center align-items-center mb-3">
                                          <img
                                            className="text-center"
                                            src={jainamXTS}
                                            alt=""
                                            width={34}
                                            style={{ marginRight: "5px" }}
                                          />
                                          <h5 className="text-center" style={{ whiteSpace: 'nowrap' }}>Jainam (XTS)</h5>
                                        </div> : props.loginType == 14 ?
                                          <div className="d-flex justify-content-center align-items-center mb-3">
                                            <img
                                              className="text-center"
                                              src={kotakneo}
                                              alt=""
                                              width={34}
                                              style={{ marginRight: "5px" }}
                                            />
                                            <h5 className="text-center" style={{ whiteSpace: 'nowrap' }}>Kotak Neo</h5>
                                          </div> : props.loginType == 15 ?
                                            <div className="d-flex justify-content-center align-items-center">
                                              <img
                                                className="text-center"
                                                src={firstock}
                                                alt=""
                                                width={34}
                                                style={{ marginRight: "5px" }}
                                              />
                                              <h5 className="text-center">Firstock</h5>
                                            </div> : props.loginType == 16 ?
                                              <div className="d-flex justify-content-center align-items-center mb-3">
                                                <img
                                                  className="text-center"
                                                  src={zebu}
                                                  alt=""
                                                  width={70}
                                                  style={{ marginRight: "5px" }}
                                                />
                                                <h5 className="text-center">Zebu</h5>
                                              </div> : props.loginType == 17 ?
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                  <img
                                                    className="text-center"
                                                    src={arrow}
                                                    alt=""
                                                    width={100}
                                                    style={{ marginRight: "5px" }}
                                                  />
                                                </div> : props.loginType == 18 ?
                                                  <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <img
                                                      className="text-center"
                                                      src={groww}
                                                      alt=""
                                                      width={100}
                                                      style={{ marginRight: "5px" }}
                                                    />
                                                  </div> : <></>

              }


            </Col>

          </Row>
          <Card>
            <Card.Body style={{ paddingTop: "0.75rem", paddingBottom: "0.5rem" }}>
              <Row className="justify-content-md-center">
                <Col xs={12} sm={12} md={12}>
                  {props.loginType == 1 ?
                    <p className="text-center text-muted mb-4" >Login using your Aliceblue credentials.</p> : props.loginType == 2 ?
                      <p className="text-center text-muted mb-4" >Login using your Fyers credentials.</p> : props.loginType == 5 ?
                        <p className="text-center text-muted mb-4" >Login using your 5paisa credentials.</p> : props.loginType == 15 ?
                          <p className="text-center text-muted mb-4" >Login using your Firstock credentials.</p> : ""
                  }
                  {props.loginType == 0 ? <p className="text-center text-muted mb-4"><small>Configure & login using your Zerodha API Key and Secret.</small></p> : ""}
                  {props.loginType == 11 ? <p className="text-center text-muted mb-4"><small className="text-muted" style={{ marginLeft: '6px' }}>XTS API Supported Broker</small></p> : ""}
                </Col>
                {/* <Col xs={12} sm={12} md={12} className="text-center">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    className=" fw-bolder  m-3"
                    >
                    Simple {props.loginType ==0 ? 'Zerodha' : 'Aliceblue '} Login
                </Button>
                
            </Col> */}

                <Col xs={12} sm={12} md={12} className="text-center" >
                  <p style={{ textAlign: "start", fontSize: "12px" }} className="mb-1 text-muted">{props.loginType == 0 ? 'Zerodha Client ID' : props.loginType == 1 ? 'Aliceblue Client ID' : props.loginType == 2 ? 'Fyers Client ID' : props.loginType == 3 ? 'ICICI Direct User ID' : props.loginType == 4 ? 'Angel One User ID' : props.loginType == 5 ? '5paisa User ID' : props.loginType == 6 ? 'Jainam Duck User ID' : props.loginType == 7 ? 'Upstox User ID ' : props.loginType == 8 ? 'Dhan Client ID' : props.loginType == 9 ? 'FlatTrade User ID' : props.loginType == 10 ? 'Shoonya User ID' : (props.loginType == 11) ? "Broker's Client ID" : props.loginType == 13 ? "Jainam (XTS) Client ID" : props.loginType == 15 ? 'Firstock User ID' : props.loginType == 14 ? 'Kotak Neo User ID' : props.loginType == 16 ? 'Zebu Client ID' : props.loginType == 17 ? 'Arrow User Name' : props.loginType == 18 ? 'Groww User Name' : ''}</p>
                  <div style={{ maxWidth: "320px", margin: "0 auto" }}>
                    <InputGroup className="mb-3">
                      <Form.Control
                        // placeholder="Enter Client ID"
                        placeholder="Enter your ID"
                        ref={props.inputRef}
                        aria-label="Enter Client ID"
                        aria-describedby="basic-addon2"
                        onChange={handleChange}
                        value={clientID}
                        onKeyDown={loginAsBorker}
                        style={{ fontSize: '12px', background: "none", padding: "4px 12px", borderRadius: "0.25rem" }}
                      />
                      <Button disabled={!clientID} variant="primary" size="sm" id="button-addon2" onClick={() => loginAsBorker('')}>
                        Login
                      </Button>
                    </InputGroup>
                  </div>
                  {errMsg && <p className='text-danger'><small>{errMsg}</small></p>}
                </Col>
                {props.loginType == 1 ?
                  <Col xs={12} sm={12} md={12} className="text-center">
                    <p >Open an Aliceblue Account today itself to access QuikTrade.com </p>
                    <Button variant="primary" id="button-addon2"  >
                      <Link style={{ color: "#fff", textDecoration: "none" }} to="https://alicebluepartner.com/open-myaccount/?TM=SMDU739" target="_blank" rel="noreferrer">Open Aliceblue Account Now</Link>
                    </Button>
                  </Col>
                  : ""}
                {props.loginType == 5 ?
                  <Col xs={12} sm={12} md={12} className="text-center">
                    <p >Open a 5paisa Account today itself to access QuikTrade.com </p>
                    <Button variant="primary" id="button-addon2"  >
                      <Link style={{ color: "#fff", textDecoration: "none" }} to="https://www.5paisa.com/demat-account?ReferralCode=57003172&ReturnUrl=invest-open-account" target="_blank" rel="noreferrer">Open 5paisa Account Now</Link>
                    </Button>
                  </Col>
                  : ""}
                {props.loginType == 15 ?
                  <Col xs={12} sm={12} md={12} className="text-center">
                    <p >Open a Firstock Account today itself to access QuikTrade.com </p>
                    <Button variant="primary" id="button-addon2"  >
                      <Link style={{ color: "#fff", textDecoration: "none" }} to="https://signup.firstock.in/?p=FNO99" target="_blank" rel="noreferrer">Open Firstock Account Now</Link>
                    </Button>
                  </Col>
                  : ""}
                {props.loginType == 8 && <span className="note-cls"><span>*</span> You will find the Dhan Client ID, under Profile Picture → It's Me → Under Manage Account → Profile & Account Details → Profile Details</span>}


              </Row>

            </Card.Body>
          </Card>
          {/* <Row>
            <Col xs={12} sm={12} md={12}>
                <Link className='mt-2'>Change api details?</Link> 
            </Col>
        </Row>     */}

        </Modal.Body>
      </Modal>
    </>
  );
}
export default BrokerLoginModal;